import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import fondo from '../../assets/img/landingPage/fondo.png';
import dashboard from '../../assets/img/landingPage/modeling/dashboar_APIDesign01.png';
import dashboard2 from '../../assets/img/landingPage/modeling/dashboar_APIDesign01.webp';

import features_1 from '../../assets/img/landingPage/modeling/a2ml-01.png'
import features_2 from '../../assets/img/landingPage/modeling/a2ml-02.png'
import features_3 from '../../assets/img/landingPage/modeling/a2ml-03.png'
import features_4 from '../../assets/img/landingPage/modeling/a2ml-04.png'

import icon_1 from '../../assets/img/landingPage/modeling/icn_A2ML-01.png'
import icon_2 from '../../assets/img/landingPage/modeling/icn_A2ML-02.png'
import icon_3 from '../../assets/img/landingPage/modeling/icn_A2ML-03.png'

import logo from '../../assets/img/logos/AVAP_APIModelingLanguage-neg.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const ModelingLanguageProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroSolutions" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo Modeling Language"
                        className="img-fluid logo mw-100"
                    />
                    <h1 className="fl-title m-0 ">Design APIs Smarter. Scale Without Friction</h1>
                    <p className="fl-subtitle pt-2">
                    Modular meta-language redefining how APIs are designed, scaled, and maintained.
                    </p>
                    {/*<a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>*/}
                    <img
                        src={dashboard}
                        alt=" Modern API Design with OAS and A2ML (AVAP API Modeling Language) 
                        for Scalable Architecture"
                        className="img-fluid mt-4"
                        style={{ 
                            width: '90%', 
                            maxWidth: '900px', 
                            height: 'auto' ,
                            paddingTop: "100px" }}
                    />      
                </section>

                {/* Powerful API Platform */}
                <section id= "subtitleSection"
                className="text-center pb-5">
                    <div className="row">
                        
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle mb-3 fl-txt-container-s">
                            AVAP Modeling Language (A2ML)
                            </p>
                            <p className="fl-text fl-txt-container-s">
                            A2ML is a modular, meta-language designed to simplify and standardize API modeling in complex, enterprise environments. It forms the structural backbone of AVAP Framework, enabling teams to design robust APIs faster, with better consistency, maintainability, and scalability.
                            </p>
                            <p className="fl-text fl-txt-container-s">
                            A2ML provides a unified approach to modeling that reduces redundancy, increases reusability, and improves team collaboration.
                            </p>
                            <p className="fl-text fl-txt-container-s">
                            Unlike traditional schema or spec-based approaches, A2ML introduces intelligent fragmentation and meta-level abstraction to align API modeling with modern engineering workflows.
                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                <section className="container pt-6 pb-5">
                    <div className="row">
                        <div className="col-md-4 ">
                            <div className="fl-pill">
                                <img 
                                src={icon_1} 
                                alt="icon_1"
                                /*className="mb-3 aboutIcon" */
                                style={{marginRight: "5px"} }
                                />
                                <p>Modular, reusable API components</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-pill">
                                <img 
                                src={icon_2} 
                                alt="icon_2" 
                               /*className="mb-3 aboutIcon"
                                */
                               style={{marginRight: "5px"}}
                                />
                                <p>Fragmentation & Reuse</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" 
                                style={{marginRight: "5px"}}/>
                                <p>Native to AVAP Framework</p>
                            </div>
                        </div>
                    </div>
                </section> 

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center order-2 order-md-1">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5 order-1 order-md-2">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Fragmentation & Reuse</h3>
                            <p className="fl-text">
                            Break complex APIs into reusable fragments and modules. Reduce duplication, simplify updates, and build a more maintainable API architecture.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5 order-1 order-md-1">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Meta-Language Architecture</h3>
                            <p className="fl-text">
                            Go beyond static specifications. A2ML defines APIs at a higher abstraction level, enabling dynamic interpretation, transformation, and integration across environments and tools.
                            </p>
                        </div>

                        <div className="col-md-6 text-center order-2 order-md-2">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center order-2 order-md-1">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5 order-1 order-md-2">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Integrated Development Flow
                            </h3>
                            <p className="fl-text">
                            A2ML is tightly integrated into AVAP Dev Studio and CLI. Move from design to deployment with validation, testing, and publishing built into your modeling pipeline. </p>
                        </div>

                    </div>
                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center order-2 order-md-2">
                            <img
                                src={features_4}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>

                        <div className="col-md-6 pl-5 order-1 order-md-1">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Platform-Native Consistency
                            </h3>
                            <p className="fl-text">
                            Ensure uniform behavior across AVAP tools and services. A2ML powers the API lifecycle from modeling to deployment, ensuring that what’s designed is what’s delivered.</p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Faster, More Consistent API Design
                                </p>
                                <p className="fl-text">
                                Accelerate development with standardized, modular structures for every API.
                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Maximum Reusability, Minimum Maintenance</p>
                                <p className="fl-text">
                                Reuse components across projects to simplify updates and reduce effort.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Seamless Integration into Dev Workflows
                                </p>
                                <p className="fl-text">
                                Design and deploy directly from your tools with full automation.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default ModelingLanguageProduct;
